import { __styles } from '@griffel/react';
export const useReducedMotionStyles = /*#__PURE__*/__styles({
  reduced: {
    Hwfdqs: "f1bggi9a"
  }
}, {
  m: [["@media screen and (prefers-reduced-motion: reduce){.f1bggi9a{transition-duration:0.01ms!important;}}", {
    m: "screen and (prefers-reduced-motion: reduce)"
  }]]
});
//# sourceMappingURL=useReducedMotionStyles.styles.js.map